export default {
  id: 247,
  title: 'Target #247 - LEDs',
  url: 'https://cssbattle.dev/play/247',
  colors: ['#606060', '#FFFFFF'],
  solution:
    '<p><style>p{position:fixed;margin:0;top:10;left:10;width:40;height:40;background:#606060;border-radius:1in;box-shadow:85px 0 #606060,170px 0 #606060,0 60px #606060,0 120px #606060,0 180px #606060,0 240px #606060,85px 240px #606060,255px 0 #fff,340px 0 #fff,340px 60px #fff,340px 120px #fff,340px 180px #fff,170px 240px #fff,255px 240px #fff,340px 240px #fff}body{background:linear-gradient(90deg,#fff 200px,#606060 200px)',
}
